<template>
  <div class="bg">
    <img src="@/assets/images/home/wss-img.png" alt="图片加载异常" />
<!--    <p> <span class="iconfont icon-xiaolian"></span> <i>|</i> 功能完善中～～~</p>-->
  </div>
</template>

<script>
export default {}
</script>

<style lang="less" scoped>
.bg {
  width: 100%;
  height: 100%;
  background-color: #fff;
  text-align: center;
  padding-top: 185px;
  // display: flex;
  // justify-content: center;
  // align-items: center;
  img {
    width: 345px;
    height: 345px;
    // margin-top: 10%;
    // min-width: 700px;
    // max-width: 700px;
    // height: 50%;
  }
  p{
    font-size: 16px;
    color: #377CF1;
    font-weight: 500;
    i{
      font-size: 16px;
      // color: #000;
      opacity: 0.4;
      padding-left: 5px;
      // padding: 0 4px 0 5px;
    }
  }
}
</style>
